const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { map } = require('lodash');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');

// @ components
const { MortgageRequestOperativeDocumentationItem } = require('./mortgageRequestOperativeDocumentationItem');

class MortgageRequestOperativeDocumentationBlock extends React.Component {
    constructor(props) {
        super(props);

        this.buildDocumentsList = this.buildDocumentsList.bind(this);
    }

    buildDocumentsList(documents) {
        const holdersListItem = map(documents, (item, index) => (
            <MortgageRequestOperativeDocumentationItem
                key={index}
                item={item}
            />
        ));

        return holdersListItem;
    }

    render() {
        const { titleKey, documents } = this.props;
        const holdersList = this.buildDocumentsList(documents);

        return (
            <ContentBox
                title={formatText(titleKey)}
                smallTitle={true}
                titleSeparator={true}
                customClassName="mortgage-request-operative-documentation__section"
            >
                <ul className="list-unstyled">
                    {holdersList}
                </ul>
            </ContentBox>
        );
    }
}

MortgageRequestOperativeDocumentationBlock.propTypes = {
    titleKey: PropTypes.string,
    documents: PropTypes.array
}

module.exports = MortgageRequestOperativeDocumentationBlock;
